export default "__VITE_ASSET__uEr12m1l__"